// src/components/LowRound/WeekGroup.js
import React from "react";
import { Grid, Typography, Button } from "@mui/material";
import RoundCard, { formatDateInEastern } from "./RoundCard";

const WeekGroup = ({ weekKey, roundsForWeek, userNames, onSelectRound, navigateToScorecard }) => {
  // Convert the weekKey into a Date.
  const weekDate = new Date(Number(weekKey));

  // For this window, select the best (lowest differential) round for each user.
  const bestRoundsMap = {};
  roundsForWeek.forEach((round) => {
    const userId = round.userId;
    if (!bestRoundsMap[userId]) {
      bestRoundsMap[userId] = round;
    } else if (
      round.differential !== undefined &&
      bestRoundsMap[userId].differential !== undefined &&
      round.differential < bestRoundsMap[userId].differential
    ) {
      bestRoundsMap[userId] = round;
    }
  });
  const bestRoundsForWeek = Object.values(bestRoundsMap).sort((a, b) => {
    if (a.differential === undefined) return 1;
    if (b.differential === undefined) return -1;
    return a.differential - b.differential;
  });
  // Limit to the top 10 rounds.
  const topRounds = bestRoundsForWeek.slice(0, 10);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <Typography variant="subtitle1" sx={{ mb: 1 }}>
        Week of {formatDateInEastern(weekDate)}
      </Typography>
      {topRounds.length === 0 ? (
        <>
          <Typography variant="body2" color="textSecondary">
            No rounds entered for this competition window.
          </Typography>
          <Button variant="contained" sx={{ mt: 1 }} onClick={navigateToScorecard}>
            Enter a New Round
          </Button>
        </>
      ) : (
        <Grid container spacing={2}>
          {topRounds.map((round, index) => (
            <Grid item xs={12} md={6} key={round.id}>
              <RoundCard
                round={round}
                placementIndex={index}
                // Pass only the fullName (a string) for RoundCard.
                userName={userNames[round.userId] ? userNames[round.userId].fullName : "Unknown Player"}
                onSelect={() => onSelectRound(round, weekDate, index)}
              />
            </Grid>
          ))}
        </Grid>
      )}
    </div>
  );
};

export default WeekGroup;